import { render, staticRenderFns } from "./UpdatedBenefitErrorNotification.vue?vue&type=template&id=f11b5140&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports